export enum Environment {
  Demo = 'demo',
  Dev = 'dev',
  Local = 'local',
  Prod = 'prod',
  Test = 'test',
}

export const isEnvironment = (env: unknown): env is Environment =>
  Object.values(Environment).includes(env as Environment);

export enum StatsigEnvironment {
  development = 'development',
  production = 'production',
  staging = 'staging',
}

const StatsigEnvMap = {
  [Environment.Demo]: StatsigEnvironment.production,
  [Environment.Dev]: StatsigEnvironment.development,
  [Environment.Local]: StatsigEnvironment.development,
  [Environment.Prod]: StatsigEnvironment.production,
  [Environment.Test]: StatsigEnvironment.staging,
} as const satisfies Record<Environment, StatsigEnvironment>;

export const getStatsigEnvironment = (deploymentEnv: Environment): StatsigEnvironment =>
  StatsigEnvMap[deploymentEnv];
